<template>
  <div class="md-card md-card-login" :class="{ 'md-card-hidden': cardHidden }">
    <div  class="md-card-header" :class="getClass(headerColor)">
      <slot name="title"></slot>
      <div v-if="false" class="social-line">
        <slot name="buttons"></slot>
      </div>
    </div>

    <div class="md-card-content">
      <slot name="description"></slot>
      <slot name="inputs"></slot>
    </div>

    <div class="md-card-actions">
      <slot name="footer"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "login-card",
  props: {
    headerColor: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      cardHidden: true,
    };
  },
  beforeMount() {
    setTimeout(this.showCard, 400);
  },
  methods: {
    showCard: function () {
      this.cardHidden = false;
    },
    getClass: function (headerColor) {
      return "md-card-header-" + headerColor + "";
    },
  },
};
</script>

<style lang="css"></style>
